var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4997 8.66634H18.4163V6.49967C18.4163 3.50967 15.9897 1.08301 12.9997 1.08301C10.0097 1.08301 7.58301 3.50967 7.58301 6.49967V8.66634H6.49967C5.30801 8.66634 4.33301 9.64134 4.33301 10.833V21.6663C4.33301 22.858 5.30801 23.833 6.49967 23.833H19.4997C20.6913 23.833 21.6663 22.858 21.6663 21.6663V10.833C21.6663 9.64134 20.6913 8.66634 19.4997 8.66634ZM12.9997 18.4163C11.808 18.4163 10.833 17.4413 10.833 16.2497C10.833 15.058 11.808 14.083 12.9997 14.083C14.1913 14.083 15.1663 15.058 15.1663 16.2497C15.1663 17.4413 14.1913 18.4163 12.9997 18.4163ZM16.358 8.66634H9.64134V6.49967C9.64134 4.64717 11.1472 3.14134 12.9997 3.14134C14.8522 3.14134 16.358 4.64717 16.358 6.49967V8.66634Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.fe9124e05a8b304174f5ff118c7f4bba.svg";
export { ForwardRef as ReactComponent };